module.exports = __webpack_public_path__ + "fonts/07fe0fec-b63f-4963-8ee1-535528b67fdb.d4820eb0.eot";